import React from 'react';
import PublicMarketerLanding from './PublicMarketerLanding';

const previewData = {
  marketer: {
    name: 'أحمد العمري',
    username: 'your-username',
    specialty: 'فلل وأراضي',
    city: 'الرياض',
    falLicense: 'FAL-12345678',
    bio: 'مستشار عقاري معتمد بخبرة تمتد لأكثر من 7 سنوات في سوق العقارات السعودي. متخصص في فلل الرياض والأراضي السكنية في المناطق الحيوية.',
    experience: 7,
    dealsDone: 120,
    // Preview services show the new services section using mock data only.
    services: [
      'بيع عقارات',
      'تأجير عقارات',
      'استشارات عقارية',
      'إفراغ عقاري',
    ],
    districts: 'النرجس · الملقا · العليا',
    priceRangeMin: 500000,
    priceRangeMax: 5000000,
    languages: 'عربي · إنجليزي',
    phone: '966501234567',
    twitter: '@ahmed_alomari',
    email: 'ahmed@example.com',
    brandColor: '#C5A880',
    totalOffers: 6,
    showAboutSection: true,
    showStatsSection: true,
    showSpecialtySection: true,
    showCatalogsSection: true,
    showOffersSection: true,
    showTestimonialsSection: false,
    showContactSection: true,
  },
  catalogs: [
    { _id: 'preview-catalog-all', name: 'كافة العروض', slug: 'preview-all', isDefault: true, offersCount: 6 },
    { _id: 'preview-catalog-villas', name: 'فلل النرجس الفاخرة', slug: 'preview-villas', offersCount: 3 },
    { _id: 'preview-catalog-land', name: 'أراضي الملقا الاستثمارية', slug: 'preview-land', offersCount: 2 },
  ],
  offers: [
    {
      _id: 'preview-offer-1',
      propertyType: 'villa',
      price: 2800000,
      title: 'فيلا دور ونصف حي النرجس',
      city: 'الرياض',
      district: 'النرجس',
      area: 420,
      coverImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80',
    },
    {
      _id: 'preview-offer-2',
      propertyType: 'land',
      price: 1200000,
      title: 'أرض سكنية في الملقا على شارعين',
      city: 'الرياض',
      district: 'الملقا',
      area: 600,
      coverImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&q=80',
    },
    {
      _id: 'preview-offer-3',
      propertyType: 'apartment',
      price: 750000,
      title: 'شقة 4 غرف في العليا بإطلالة',
      city: 'الرياض',
      district: 'العليا',
      area: 180,
      coverImage: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80',
    },
    {
      _id: 'preview-offer-4',
      propertyType: 'villa',
      price: 3500000,
      title: 'فيلا مستقلة في حي الياسمين',
      city: 'الرياض',
      district: 'الياسمين',
      area: 500,
      coverImage: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600&q=80',
    },
    {
      _id: 'preview-offer-5',
      propertyType: 'commercial',
      price: 1800000,
      title: 'محل تجاري في الدور الأرضي',
      city: 'الرياض',
      district: 'العليا',
      area: 90,
      coverImage: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&q=80',
    },
    {
      _id: 'preview-offer-6',
      propertyType: 'land',
      price: 980000,
      title: 'أرض تجارية في طريق الملك فهد',
      city: 'الرياض',
      district: 'العليا',
      area: 400,
      coverImage: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80',
    },
  ],
};

export default function PublicMarketerPreview() {
  // Preview only sends mock data; all layout and styling comes from PublicMarketerLanding.
  return <PublicMarketerLanding previewData={previewData} isPreview />;
}
